import { Environment } from '@abp/ng.core';

const baseUrl = 'https://xlite-pms-test.lotussolution.cloud';

export const environment = {
  production: true,
  serviceWorker: true,
  application: {
    baseUrl,
    name: 'OrdWebApp',
    logoUrl: '',
  },
  oAuthConfig: {
    issuer: 'https://sso.apecgroup.net/realms/SmartHotel',
    redirectUri: window.location.origin,
    clientId: 'SmartHotel',
    // responseType: 'code',
    scope: 'code',
    requireHttps: false,
    dummyClientSecret: '138664e4-ab83-4801-8af3-7050b96796af',
  },
  odicConfig: {
    authority: 'https://sso.apecgroup.net/realms/SmartHotel',
    redirectUrl: window.location.origin + '/callback',
    postLogoutRedirectUri: window.location.origin,
    clientId: 'SmartHotel',
    scope: 'openid profile', // 'openid profile ' + your scopes
    responseType: 'code',
    silentRenew: true,
    silentRenewUrl: window.location.origin + '/silent-renew.html',
    renewTimeBeforeTokenExpiresInSeconds: 10,
    autoUserInfo: false,
    secureRoutes: ['/**'],
  },
  apis: {
    default: {
      url: 'https://xlite-pms-test.lotussolution.cloud/reservation',
      rootNamespace: 'OrdWebApp',
    },
    hk: {
      url: 'https://xlite-pms-test.lotussolution.cloud/housekeeping',
      rootNamespace: 'HkWebApp',
    },
    cf: {
      url: 'https://xlite-pms-test.lotussolution.cloud/configuration',
      rootNamespace: 'OrdWebApp',
    },
    socket: {
      // url: 'http://10.0.0.80:8182',
      url: ''
    },
    socket_identity: {
      url: 'https://192.168.5.1:8000'
    },
  },
  base: {
    cf: '/cf',
  },
  mcfe: 'dev',
  i18n: '/assets/i18n',
  versionCheckUrl: '/api/version',
  versionPollMs: 3 * 60 * 1000,
};
